const pad = (value) => String(value).padStart(2, "0");

// Formats a Date as local "YYYY-MM-DDTHH:mm" for datetime-local inputs.
export const toDateTimeLocal = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;

export const getMinDateTimeLocal = () => toDateTimeLocal(new Date(Date.now() + 60 * 1000));

export const isFutureDate = (date) => date.getTime() > Date.now();

// Existing date as local datetime-local value, regardless of past/future.
export const toExistingDateTimeLocal = (value) => {
  const date = value ? new Date(value) : null;
  return date && !Number.isNaN(date.getTime()) ? toDateTimeLocal(date) : "";
};

// Prefills an existing date only when it is still in the future.
export const toFutureDateTimeLocal = (value) => {
  const date = value ? new Date(value) : null;
  return date && !Number.isNaN(date.getTime()) && isFutureDate(date) ? toDateTimeLocal(date) : "";
};
